export const SELECT_TYPES = {
  MULTIPLE: 'multiple',
  CREATABLE: 'tags',
} as const;

export type SelectType = (typeof SELECT_TYPES)[keyof typeof SELECT_TYPES];
